import React, { FunctionComponent, useState } from 'react';

import { Dropdown } from 'react-bootstrap';
import 'surveys/results/feed/components/result-list/response-editor/new-feed/ResponseOptions.scss';

export interface OptionItem {
    id: number;
    label: string;
    value: string;
}

interface Props {
    options: OptionItem[];
    defaultSelected?: string;
    onOptionSelect?: (value: string) => void;
}

export const ResponseOptions: FunctionComponent<Props> = ({
    options,
    defaultSelected = 'location',
    onOptionSelect,
}) => {
    const [selectedOption, setSelectedOption] = useState<string>(defaultSelected);
    const handleSelect = (value: string) => {
        setSelectedOption(value);
        if (onOptionSelect) {
            onOptionSelect(value);
        }
    };
    const selectedLabel = options.find((option) => option.value === selectedOption)?.label || '';

    return (
        <div className="response-options">
            <Dropdown className="w-100">
                <Dropdown.Toggle variant="outline-secondary" className="w-100">
                    {selectedLabel}
                </Dropdown.Toggle>
                <Dropdown.Menu className="w-100">
                    {options.map((option) => (
                        <Dropdown.Item
                            key={option.id}
                            onClick={() => handleSelect(option.value)}
                            active={selectedOption === option.value}
                        >
                            {option.label}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};
